// Gift wrap without the Wrapped app (Hamza 2026-10-14). Markup: snippets/bjo-giftwrap.liquid.
// Product page: switch + paper + Receiver/Sender/Message → properties on the item and a linked
// "BambiniJO Gift Wrap" line (same _Wrapped Bundle). Every page: keep each wrap line in step with its item.
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const post = (url, body) =>
    fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
  const isWrap = (i) => (i.handle || '').includes('gift-wrap');
  const onCart = () => /\/cart\/?$/.test(location.pathname);

  // Wrap lines follow their item: qty = item qty, paper = chosen paper, no wrap without an item.
  // Lines without _Wrapped Bundle (the registry's whole-order wrap) are left alone. Returns true if the cart changed.
  async function sync() {
    const cart = await (await fetch(root + 'cart.js')).json();
    const groups = {};
    for (const i of cart.items) {
      const b = i.properties && i.properties['_Wrapped Bundle'];
      if (!b) continue;
      const g = groups[b] || (groups[b] = { qty: 0, vid: 0, wraps: [] });
      if (isWrap(i)) g.wraps.push(i);
      else { g.qty += i.quantity; g.vid = g.vid || Number(i.properties['_Gift Option ID']) || 0; }
    }
    let changed = false;
    for (const [b, g] of Object.entries(groups)) {
      const keep = g.qty ? g.wraps.find((w) => !g.vid || w.variant_id === g.vid) : null;
      for (const w of g.wraps) if (w !== keep) { await post('cart/change.js', { id: w.key, quantity: 0 }); changed = true; }
      if (keep && keep.quantity !== g.qty) { await post('cart/change.js', { id: keep.key, quantity: g.qty }); changed = true; }
      if (!keep && g.qty && g.vid) { await post('cart/add.js', { items: [{ id: g.vid, quantity: g.qty, properties: { '_Wrapped Bundle': b } }] }); changed = true; }
    }
    return changed;
  }
  let queue = Promise.resolve();
  const resync = () => {
    queue = queue.then(sync).then((changed) => { if (changed && onCart()) location.reload(); /* subtotal + rows both change; rare (a wrapped item's qty moved) */ }).catch(() => {});
    return queue;
  };

  function widget(box) {
    const form = document.getElementById(box.dataset.form);
    if (!form) return;
    const cb = box.querySelector('.bjo-gw__on');
    const msg = box.querySelector('textarea');
    const left = box.querySelector('.bjo-gw__left');
    const ar = document.documentElement.lang === 'ar';
    cb.addEventListener('change', () => box.classList.toggle('is-on', cb.checked));
    msg.addEventListener('input', () => {
      const n = 250 - msg.value.length;
      left.textContent = n <= 50 ? (ar ? 'متبقٍ ' + n : n + ' left') : '';
    });
    // Capture runs before the theme's own submit handler reads the form: add the wrap as hidden properties (or take them out).
    document.addEventListener('submit', (e) => {
      if (e.target !== form) return;
      form.querySelectorAll('.bjo-gw-prop').forEach((n) => n.remove());
      if (!cb.checked) return;
      const paper = box.querySelector('.bjo-gw__paper input:checked') || box.querySelector('.bjo-gw__paper input');
      if (!paper) return;
      const props = { 'Gift Wrap': 'yes', 'Gift Option': paper.dataset.name, '_Gift Option ID': paper.value, '_Wrapped Bundle': Math.random().toString(16).slice(2, 10).padEnd(8, '0') };
      box.querySelectorAll('.bjo-gw__f').forEach((f) => { if (f.value.trim()) props[f.dataset.k] = f.value.trim(); });
      for (const [k, v] of Object.entries(props)) {
        const i = document.createElement('input');
        i.type = 'hidden'; i.className = 'bjo-gw-prop'; i.name = 'properties[' + k + ']'; i.value = v;
        form.append(i);
      }
    }, true);
  }

  const init = () => document.querySelectorAll('.bjo-gw:not([data-ready])').forEach((b) => { b.dataset.ready = '1'; widget(b); });
  init();
  document.addEventListener('DOMContentLoaded', init);
  // the wrap line is added right after the item lands in the cart; any other cart change re-checks the pairs
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, resync); // PUB_SUB_EVENTS is a top-level const, not on window
  if (onCart()) resync();
})();
